import { render, staticRenderFns } from "./SearchContainer.vue?vue&type=template&id=0b253f5c&"
import script from "./SearchContainer.vue?vue&type=script&lang=js&"
export * from "./SearchContainer.vue?vue&type=script&lang=js&"
import style0 from "./SearchContainer.vue?vue&type=style&index=0&id=0b253f5c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports